__webpack_require__.p = "/pripomienky-fe/";